import React, { useState } from "react";

const ShowMoreText = ({ text, shortLimit = 40, lineLimit = 50 }) => {
  const [showMore, setShowMore] = useState(false);

  const toggle = () => setShowMore((prev) => !prev);

  const formatWithLineBreaks = (str, limit) => {
    const parts = [];
    for (let i = 0; i < str.length; i += limit) {
      parts.push(str.slice(i, i + limit));
    }
    return parts.map((part, index) => (
      <span key={index}>
        {part}
        <br />
      </span>
    ));
  };

  const shortText =
    text.length > shortLimit ? `${text.slice(0, shortLimit)}...` : text;

  return (
    <div>
      <span>
        {showMore ? formatWithLineBreaks(text, lineLimit) : shortText}
      </span>
      {text.length > shortLimit && (
        <button
          onClick={toggle}
          className="text-blue-600 text-xs hover:underline ml-1"
        >
          {showMore ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default ShowMoreText;
